const escapeHtmlAttr = (value: string) => value
  .replaceAll('&', '&amp;')
  .replaceAll('"', '&quot;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;');

const getImageDimensions = (attrs: string) => {
  const widthMatch = attrs.match(/\bwidth\s*=\s*(\d+)\b/i);
  const heightMatch = attrs.match(/\bheight\s*=\s*(\d+)\b/i);

  if (!widthMatch || !heightMatch) return null;

  return {
    width: widthMatch[1],
    height: heightMatch[1],
  };
};

/**
 * Public local blog articles support a small image extension so we can reserve
 * layout space without affecting markdown behavior outside the public flow.
 *
 * Accepted examples:
 * ![Alt](/blog/img/example.png){width=600 height=331}
 * ![Alt](/blog/img/example.png) { height = 331 width = 600 }
 */
const renderLocalPublicBlogMarkdown = (markdown: string) => markdown.replaceAll(
  /!\[([^\]]*)\]\((\/blog\/img\/[^)\s]+)\)\s*\{([^}]*)\}/g,
  (match, alt: string, src: string, attrs: string) => {
    const dimensions = getImageDimensions(attrs);

    if (!dimensions) return match;

    return `<img src="${src}" alt="${escapeHtmlAttr(alt)}" width="${dimensions.width}" height="${dimensions.height}">`;
  }
);

export default renderLocalPublicBlogMarkdown;
